import script from "./MoleculeList.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeList.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeList.vue?vue&type=style&index=0&id=9641a774&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9641a774"]])

export default __exports__